import { render } from "./GroupTerms.vue?vue&type=template&id=cdada996&scoped=true"
import script from "./GroupTerms.vue?vue&type=script&lang=js"
export * from "./GroupTerms.vue?vue&type=script&lang=js"

import "./GroupTerms.vue?vue&type=style&index=0&id=cdada996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdada996"]])

export default __exports__